import es_ES from './es_ES';
import en_US from './en_US';
import fr_FR from './fr_FR';
import it_IT from './it_IT';


const locales = {
    "es-ES": es_ES,
    "en-US": en_US,
    "fr-FR": fr_FR,
    "it-IT": it_IT
}

export default locales;